import { useEffect, useState } from "react";
import axios from "axios";
import { siteConfig } from "../config/siteConfig";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Returns reviews + per-platform stats.
 *
 * - If the backend `/api/reviews` endpoint returns `live=true` (i.e. an
 *   API key for Google/Agoda/TripAdvisor has been configured in backend/.env),
 *   live data is used.
 * - Otherwise falls back to the curated reviews in `siteConfig.reviews` and
 *   `siteConfig.reviewStats`.
 *
 * Shape:
 *   { reviews: [...], stats: { google, agoda, tripadvisor }, live: bool, loading: bool }
 */
export function useReviews() {
  const [data, setData] = useState({
    reviews: siteConfig.reviews,
    stats: siteConfig.reviewStats,
    live: false,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/reviews`, { timeout: 6000 });
        const items = res.data?.items || [];
        if (cancelled) return;
        if (res.data?.live && items.length > 0) {
          setData({
            reviews: items,
            stats: res.data.stats || siteConfig.reviewStats,
            live: true,
            loading: false,
          });
        } else {
          setData((d) => ({ ...d, loading: false }));
        }
      } catch (err) {
        if (!cancelled) {
          // backend not reachable — silently use curated data
          setData((d) => ({ ...d, loading: false }));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return data;
}
